import { PermissionTooltip } from '@/shared/ui';
import { ApprovalActionButton } from '@/shared/ui/ApprovalActionButton';

import type { AssetApproval } from '../../hooks/useAssetApproval';

export interface AssetApprovalCtaProps {
  approval: AssetApproval;
}

export function AssetApprovalCta({ approval }: AssetApprovalCtaProps) {
  return (
    <PermissionTooltip disabled={approval.disabled}>
      <ApprovalActionButton
        approved={approval.kind === 'approved'}
        disabled={approval.isUpdating || approval.disabled}
        onClick={approval.onApprove}
      />
    </PermissionTooltip>
  );
}

AssetApprovalCta.displayName = 'AssetApprovalCta';
